import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ckUpdatePack,ceTogglePack } from '../../../redux/actions/checkout_operations';
import Faq from './faq';
import {
  lpPattern, P_SELECT_PACK_1, P_SELECT_PACK_2, P_SELECT_PACK_3,
} from '../../../tracking/pattern_detector';
import lpApp from '../../../app/lp_app';


class _threeColumnsPack extends Component {
  constructor(props) {
    super(props);

    this.onChoose = this.onChoose.bind(this);
    this.state = {
      packs: _threeColumnsPack.getPacksFeatures(),
      packNames: this.getPackInfo(),
    };
  }

  onChoose(e) {
    console.log("event", e, e.target.attributes['data-pack'])
    const chosenPack = +(e.target.attributes['data-pack'].value);
    if (chosenPack === 1) this.props.selectOne();
    else if (chosenPack === 2) this.props.selectTwo();
    else this.props.selectThree();
    this.props.togglePack(true);
  }

  getPackInfo() {
    switch (lpApp.contractMetaId) {
      /*
             * Checkout SAS & SASU & SARL & EURL
             */
      case 175:
      case 198:
      case 197:
      case 176:
        return [
          {
            title: 'Statuts seuls',
            sub: 'Vous créez seul',
            price: `${this.props.third_price}€`,
            fees: false,
          },
          {
            title: 'Création Standard',
            sub: "On s'occupe de tout",
            price: `${this.props.second_price}€`,
            fees: '+ frais administratifs (261,21€)',
          },
          {
            title: 'Création Express',
            sub: 'Traité sous 24H',
            price: `${this.props.first_price}€`,
            fees: '+ frais administratifs (261,21€)',
          },
        ];
      case 124:
        return [
          {
            title: 'Statuts seuls',
            sub: 'Vous créez seul',
            price: `${this.props.third_price}€`,
            fees: false,
          },
          {
            title: 'Création Standard',
            sub: "On s'occupe de tout",
            price: `${this.props.second_price}€`,
            fees: '+ frais administratifs (290,10€)',
          },
          {
            title: 'Création Express',
            sub: 'Traité sous 24H',
            price: `${this.props.first_price}€`,
            fees: '+ frais administratifs (290,10€)',
          },
        ];
      // ASSO
      case 162:
        return [
          {
            title: 'Statuts seuls',
            sub: 'Vous créez seul',
            price: `${this.props.third_price}€`,
          },
          {
            title: 'Création Standard',
            sub: "On s'occupe de tout",
            price: `${this.props.second_price}€`,
          },
          {
            title: 'Création Express',
            sub: 'Traité sous 24H',
            price: `${this.props.first_price}€`,
          },
        ];
      case 184:
      return [
        {
          title: "Pack expert",
          sub: "Je me débrouille seul",
          price: this.props.third_price + "€",
          fees: false
        },
        {
          title: "Pack confort",
          sub: "Un avocat m'accompagne",
          price: this.props.second_price + "€",
          fees: false
        },
        {
          title: "Pack sérénité",
          sub: "Un avocat gère tout mon dossier",
          price: this.props.first_price + "€",
          fees: false
        }
        ];
      default:
        break;
    }
  }


  static getPacksFeatures() {
    switch (lpApp.contractMetaId) {
      /*
             * Checkout SAS (175) & Checkout SASU (176) & EURL & SARL
             */
      case 198:
      case 197:
      case 175:
      case 176:
        return [
          {
            title: 'Statuts de',
            dynamic: true,
            isTitle: true,
            isSpacer: false,
            checks: [true, true, true],
          }, {
            title: 'Vérification du dossier',
            isTitle: false,
            isSpacer: false,
            checks: [false, true, true],
          }, {
            title: 'Immatriculation auprès du greffe',
            isTitle: false,
            isSpacer: false,
            checks: [false, true, true],
          }, {
            title: 'Garantie anti-rejet',
            isTitle: false,
            isSpacer: false,
            checks: [false, true, true],
          }, {
            title: "Publication de l'annonce légale",
            isTitle: false,
            isSpacer: false,
            checks: [false, true, true],
          }, {
            title: 'Obtention du Kbis',
            isTitle: false,
            isSpacer: true,
            checks: [false, true, true],
          }, {
            title: 'Traitement express (24h)',
            isTitle: false,
            isSpacer: false,
            checks: [false, false, true],
          }, {
            title: 'Assistance téléphonique illimitée',
            isTitle: false,
            isSpacer: false,
            checks: [false, false, true],
          },
        ];
      case 124:
        return [
          {
            title: 'Statuts de',
            dynamic: true,
            isTitle: true,
            isSpacer: false,
            checks: [true, true, true],
          }, {
            title: 'Vérification du dossier',
            isTitle: false,
            isSpacer: false,
            checks: [false, true, true],
          }, {
            title: 'Immatriculation auprès du greffe',
            isTitle: false,
            isSpacer: false,
            checks: [false, true, true],
          }, {
            title: 'Garantie anti-rejet',
            isTitle: false,
            isSpacer: false,
            checks: [false, true, true],
          }, {
            title: "Publication de l'annonce légale",
            isTitle: false,
            isSpacer: false,
            checks: [false, true, true],
          }, {
            title: 'Obtention du Kbis',
            isTitle: false,
            isSpacer: true,
            checks: [false, true, true],
          }, {
            title: 'Traitement express (24h)',
            isTitle: false,
            isSpacer: false,
            checks: [false, false, true],
          }, {
            title: 'Assistance téléphonique illimitée',
            isTitle: false,
            isSpacer: false,
            checks: [false, false, true],
          },
        ];
        // ASSO
        case 162:
            return [
              {
                title: "Statuts d'",
                dynamic: true,
                isTitle: true,
                isSpacer: false,
                checks: [true, true, true],
              }, {
                title: 'Dossier Complet Création\n(Formulaires Cerfa, mandat,attestation de domiciliation, PV d\'assemblée générale)',
                isTitle: false,
                isSpacer: false,
                checks: [false, true, true],
              }, 
              { 
                title: 'Dossier Complet Vie de l\'Association\n(bulletin d\'adhésion, feuille de présence)',
                isTitle: false,
                isSpacer: false,
                checks: [false, false, true],
              },
              {
                title: 'Enregistrement de l\'association',
                isTitle: false,
                isSpacer: false,
                checks: [false, true, true],
              }, {
                title: 'Échanges avec la Préfecture',
                isTitle: false,
                isSpacer: false,
                checks: [false, false, true],
              },{
                title: 'Assistance obtention du SIRET',
                isTitle: false,
                isSpacer: false,
                checks: [false, false, true],
              }, {
                title: 'Assistance téléphonique illimitée',
                isTitle: false,
                isSpacer: false,
                checks: [false, false, true],
              }, {
                title: 'Traitement express (24h)',
                isTitle: false,
                isSpacer: false,
                checks: [false, false, true],
              }, {
                title: 'Garantie anti-rejet',
                isTitle: false,
                isSpacer: false,
                checks: [false, false, true],
              },
            ];
      // rupture conventionnelle
      case 184:
        return [
          {
            title: "Dossier juridique complet",
            dynamic: false,
            isTitle: true,
            isSpacer: false,
            checks: [true, true, true]
          },{
            title: "Vérification de l'ensemble du dossier par un avocat",
            isTitle: false,
            isSpacer: false,
            checks: [false, true, true]
          },{
            title: "Calculs des indemnités par un avocat",
            isTitle: false,
            isSpacer: true,
            checks: [false, true, true]
          },{
            title: "Accompagnement tout au long de la procédure ",
            isTitle: false,
            isSpacer: false,
            checks: [false, false, true]
          },{
            title: "Dépot du dossier jusqu'à homologation",
            isTitle: false,
            isSpacer: false,
            checks: [false, false, true]
          },{
            title: "Signature d'un accord transactionnel (si besoin)",
            isTitle: false,
            isSpacer: true,
            checks: [false, false, true]
          }
        ];
      default:
        break;
    }
  }

  render() {
    const getContractName = (contractMetaId) => {
      switch (contractMetaId) {
        case 198:
          return 'EURL';
        case 197:
          return 'SARL';
        case 175:
          return 'SAS';
        case 176:
          return 'SASU';
        case 124:
          return 'SCI';
        case 162:
              return 'association';
        case 184:
          return "Rupture Conventionnelle";
        default:
          break;
      }
    };

    const getPackInfo = (packIndex) => {
      const packList = [];
      this.state.packs.forEach((opt, i) => {
        if (opt.checks[packIndex] === true) {
          let lineClassName = '';
          if (opt.isTitle) {
            lineClassName = 'is-title';
          } else if (opt.isSpacer) {
            lineClassName = 'is-spacer';
          }
          // with space on Asso (162) product
          const sperator = lpApp.contractMetaId === 162 ? '': ' '

          const li = (
            <li key={`cemobpck-${i}`} className={lineClassName}>
              <i className="icn-checkmark" />
              {(opt.dynamic)
                ? (
                  <span>
                    {opt.title}
                    {sperator}
                    {getContractName(lpApp.contractMetaId)}
                    {' '}
                    {((packIndex === 1 || packIndex === 2) && (lpApp.contractMetaId !== 162 )) ? '+ dossier complet' : ''}
                    {' '}
                  </span>
                )
                : (
                  <span>
                    {opt.title}
                    {' '}
                  </span>
                )}
            </li>
          );
          packList.push(li);
        }
      });

      return packList;
    };

    // let getExpDate = () => {
    //     let nomsDesMois = [
    //         {month: "janvier", days: 31},
    //         {month: "février", days: 30},
    //         {month: "mars", days: 31},
    //         {month: "avril", days: 30},
    //         {month: "mai", days: 31},
    //         {month: "juin", days: 30},
    //         {month: "juillet", days: 31},
    //         {month: "août", days: 31},
    //         {month: "septembre", days: 30},
    //         {month: "octobre", days: 31},
    //         {month: "novembre", days: 30},
    //         {month: "décembre", days: 31}
    //     ];
    //     let date = new Date();
    //     let m = date.getMonth();
    //     let y = date.getFullYear();
    //     let d = nomsDesMois[m].days;
    //     console.log(d);
    //     return ("" + d + " " + nomsDesMois[m].month + " " + y);
    // }
    // let expDate = getExpDate();

    return (
      <div>
        <section>
          <div className="container">
            {(lpApp.contractMetaId === 184) ?
              (<div className="sc-heading">
                <h1 className="sc-title">Votre rupture conventionnelle est presque prête</h1>
                <p className="sc-stitle">Choisissez votre niveau d'accompagnement</p>
              </div>) :
              (<div className="sc-heading">
                <h1 className="sc-title">Votre {getContractName(lpApp.contractMetaId)} est prête à être créée</h1>
                <p className="sc-stitle">Choisissez votre pack, nous gérons ensuite toutes les démarches</p>
              </div>) }
            <div>
              <ul className="pricing-table-x5">
                <li className="pt-pack">
                  <div className="pack-head">
                    <h2 className="pack-title">{this.state.packNames[0].title}</h2>
                    <span className="pack-stitle">{this.state.packNames[0].sub}</span>
                  </div>
                  <div className="pack-pricing">
                    <h4 className="px-pricing">
                      <div className="price-current">
                        <span className="pp-value">{this.state.packNames[0].price}</span>
                        <span className="pp-tax">HT</span>
                      </div>
                    </h4>
                    <div className="pp-mention">{(this.state.packNames[0].fees) ? this.state.packNames[0].fees : 'Sans frais administratifs'}</div>
                  </div>
                  <div className="xcta" href="#" data-pack="3" onClick={this.onChoose}>Choisir ce pack</div>
                  <ul className="pack-features">
                    {getPackInfo(0)}
                  </ul>
                </li>
                <li className="pt-pack">
                  <div className="pack-head">
                    <h2 className="pack-title">{this.state.packNames[1].title}</h2>
                    <span className="pack-stitle">{this.state.packNames[1].sub}</span>
                  </div>
                  <div className="pack-pricing">
                    <h4 className="px-pricing">
                      <div className="price-current">
                        <span className="pp-value">{this.state.packNames[1].price}</span>
                        <span className="pp-tax">HT</span>
                      </div>
                    </h4>
                    <div className="pp-mention">{(this.state.packNames[1].fees) ? this.state.packNames[1].fees : 'Sans frais administratifs'}</div>
                  </div>
                  <div className="xcta" href="#" data-pack="2" onClick={this.onChoose}>Choisir ce pack</div>
                  <ul className="pack-features">
                    {getPackInfo(1)}
                  </ul>
                </li>
                <li className="pt-pack pt-premium">
                  <div className="pack-premium-mention"><div>Le  plus populaire</div></div>
                  <div className="pack-head">
                    <h2 className="pack-title">{this.state.packNames[2].title}</h2>
                    <span className="pack-stitle">{this.state.packNames[2].sub}</span>
                  </div>
                  <div className="pack-pricing">
                    <h4 className="px-pricing">
                      <div className="price-current">
                        <span className="pp-value">{this.state.packNames[2].price}</span>
                        <span className="pp-tax">HT</span>
                      </div>
                    </h4>
                    <div className="pp-mention">{(this.state.packNames[2].fees) ? this.state.packNames[2].fees : 'Sans frais administratifs'}</div>
                  </div>
                  <div className="xcta" href="#" data-pack="1" onClick={this.onChoose}>Choisir ce pack</div>
                  <ul className="pack-features">
                    {getPackInfo(2)}
                  </ul>
                </li>
              </ul>
              <div className="marketing-args">
                <div className="flex-media checkout-assistance">
                  <div className="fm-obj">
                    <img src="/wizard/img/ma-phone.svg" />
                  </div>
                  <div className="fm-body">
                    <div className="fm-title">Assistance Téléphonique</div>
                    <div className="fm-stitle">Pour tout renseignement</div>
                  </div>
                </div>
                <div className="flex-media x3-payement">
                  <div className="fm-obj">
                    <img src="/wizard/img/ma-euro.svg" />
                  </div>
                  <div className="fm-body">
                    <div className="fm-title">Payez en 3 fois</div>
                    <div className="fm-stitle">Sans frais supplémentaires</div>
                  </div>
                </div>
                <div className="flex-media wg-avis">
                  <div className="fm-obj">
                    <img src="/wizard/img/ma-avis.svg" />
                  </div>
                  <div className="fm-body">
                    <div className="fm-title">Satisfaction Garantie</div>
                    <div className="fm-content">
                      <div className="rb-stars">
                        <span className="icn-star-full" />
                        <span className="icn-star-full" />
                        <span className="icn-star-full" />
                        <span className="icn-star-full" />
                        <span className="icn-star-half" />
                      </div>
                      <div className="wa-avis"><a target="_blank" rel="noopener noreferrer" href="https://fr.trustpilot.com/review/legalplace.fr">sur 451 avis</a></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {(lpApp.contractMetaId !== 184) ?
          <Faq />
          : ""}
      </div>
  );
  }
}


const mapStateToProps = state => ({
  first_price: state.checkout_operations.prices.first_price,
  second_price: state.checkout_operations.prices.second_price,
  third_price: state.checkout_operations.prices.third_price,
  chosen_pack: state.checkout_operations.pack,
  pricing_loading: state.loading_details.pricing,
  promo_percentage: state.checkout_operations.promo_percentage,
  title: state.contract.name,
});

const mapDispatchToProps = dispatch => ({
  togglePack: (val) => {
    dispatch(ceTogglePack(val));
  },
  selectOne: () => {
    dispatch(ckUpdatePack(0));
    lpPattern.trackInPayment(P_SELECT_PACK_1);
  },
  selectTwo: () => {
    dispatch(ckUpdatePack(1));
    lpPattern.trackInPayment(P_SELECT_PACK_2);
  },
  selectThree: () => {
    dispatch(ckUpdatePack(2));
    lpPattern.trackInPayment(P_SELECT_PACK_3);
  },
});

const ThreeColumnsPack = connect(mapStateToProps, mapDispatchToProps)(_threeColumnsPack);

export default ThreeColumnsPack;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/threeColumnsPack.js